import React, { useState } from 'react';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import ArrowDownSimple from 'components/icons/iconArrowDownSimple';
import ShowroomLocatorContent from './ShowroomLocatorContent';

const MobileShowroomLocator = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className="w-full border-b border-solid border-gray-light5 bg-white"
      style={{ display: 'block' }}
    >
      <button
        onClick={toggleExpanded}
        className="w-full flex justify-between items-center px-[3.333vw] py-4 text-left cursor-pointer"
        type="button"
      >
        <span className="text-gray font-bold text-[.78rem]">Location</span>
        {!isExpanded ? (
          <IconArrowRightSimple />
        ) : (
          <ArrowDownSimple width={16} height={9} />
        )}
      </button>

      {isExpanded && (
        <div className="w-full bg-white">
          <div className="px-[3.333vw] pb-4">
            <div className="text-sm text-gray mb-3">
              Find your closest showroom
            </div>
            <ShowroomLocatorContent
              inputId="mobile-showroom-zipcode"
              className="p-0 bg-transparent"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileShowroomLocator;
